import villaNoelia from "@/assets/marbella-villa-noelia.webp";
import noelia2 from "@/assets/marbella-noelia-2.webp";
import noelia3 from "@/assets/marbella-noelia-3.webp";
import noelia4 from "@/assets/marbella-noelia-4.webp";
import noelia5 from "@/assets/marbella-noelia-5.webp";
import noelia6 from "@/assets/marbella-noelia-6.webp";

import villaVeronique from "@/assets/marbella-villa-veronique.webp";
import veronique2 from "@/assets/marbella-veronique-2.webp";
import veronique3 from "@/assets/marbella-veronique-3.webp";
import veronique4 from "@/assets/marbella-veronique-4.webp";
import veronique5 from "@/assets/marbella-veronique-5.webp";
import veronique6 from "@/assets/marbella-veronique-6.webp";

import villaTorremuelle from "@/assets/marbella-villa-torremuelle.webp";
import torremuelle2 from "@/assets/marbella-torremuelle-2.webp";
import torremuelle3 from "@/assets/marbella-torremuelle-3.webp";
import torremuelle4 from "@/assets/marbella-torremuelle-4.webp";
import torremuelle5 from "@/assets/marbella-torremuelle-5.webp";
import torremuelle6 from "@/assets/marbella-torremuelle-6.webp";

import villaSuzanna from "@/assets/marbella-villa-suzanna.webp";
import suzanna2 from "@/assets/marbella-suzanna-2.webp";
import suzanna3 from "@/assets/marbella-suzanna-3.webp";
import suzanna4 from "@/assets/marbella-suzanna-4.webp";
import suzanna5 from "@/assets/marbella-suzanna-5.webp";
import suzanna6 from "@/assets/marbella-suzanna-6.webp";

export interface MarbellaResidence {
  slug: string;
  name: string;
  location: string;
  image: string;
  images: string[];
  bedrooms: string;
  bathrooms: string;
  guests: string;
  pools: string;
  features: string[];
  pricing: {
    low: string;
    high: string;
  };
  priceNote: string;
  description: string;
  highlights: string[];
  distances: { place: string; time: string }[];
}

export const marbellaResidences: MarbellaResidence[] = [
  {
    slug: "villa-lisa",
    name: "Villa LISA",
    location: "Benahavís, Marbella",
    image: villaNoelia,
    images: [villaNoelia, noelia2, noelia3, noelia4, noelia5, noelia6],
    bedrooms: "6",
    bathrooms: "6",
    guests: "Up to 12",
    pools: "1",
    features: [
      "Heated saltwater pool",
      "Panoramic sea views",
      "Home cinema",
      "Elevator",
      "Fitness room",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Roof terrace with outdoor kitchen",
      "BBQ & fireplace",
      "Sound system",
      "Security system",
    ],
    pricing: {
      low: "€18.000",
      high: "€28.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "In Benahavís, one of Marbella's most sought-after areas, Villa Noelia blends contemporary elegance with tranquility. Surrounding the villa, Michelin-starred restaurants and world-class golf courses create a refined backdrop for an elevated retreat.\n\nThe villa features six spacious en-suite bedrooms with sea views, open-plan living areas filled with natural light, a fully equipped designer kitchen, and a private cinema room. An elevator connects all floors effortlessly.\n\nOutside, a heated saltwater pool overlooks the Mediterranean, surrounded by manicured gardens, sunbeds, and a panoramic roof terrace with outdoor kitchen — perfect for both relaxation and entertaining under the Andalusian sun.",
    highlights: [
      "Prime Benahavís location near Michelin-starred dining",
      "Direct Mediterranean sea views from every level",
      "Contemporary architecture with luxury finishes",
      "Panoramic roof terrace with outdoor kitchen",
    ],
    distances: [
      { place: "Puerto Banús", time: "10 min drive" },
      { place: "Marbella Old Town", time: "15 min drive" },
      { place: "Beach", time: "10 min drive" },
      { place: "Málaga Airport", time: "50 min drive" },
    ],
  },
  {
    slug: "villa-angelique",
    name: "Villa ANGELIQUE",
    location: "Nueva Andalucía, Marbella",
    image: villaVeronique,
    images: [villaVeronique, veronique2, veronique3, veronique4, veronique5, veronique6],
    bedrooms: "5",
    bathrooms: "5",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Heated saltwater infinity pool",
      "Mountain & nature panoramic views",
      "Covered terrace with pergola",
      "Fire pit",
      "Ping-pong table",
      "SONOS sound system",
      "Wood fireplace",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "BBQ area",
      "Mediterranean garden",
    ],
    pricing: {
      low: "€13.400",
      high: "€20.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Set in the sought-after Golf Valley of Nueva Andalucía, Villa Veronique offers comfort, privacy, and stunning panoramic views across the valley toward La Concha mountain. The lush Mediterranean and tropical gardens create a sense of seclusion and calm.\n\nThe villa features five elegant bedrooms, each with en-suite bathrooms, along with spacious living areas that flow seamlessly into the outdoor terraces. The heated saltwater infinity pool overlooks the green surroundings, while the covered terrace with pergola and fire pit provides the perfect setting for al fresco dining and evening gatherings.\n\nNueva Andalucía is renowned for its world-class golf courses, proximity to Puerto Banús, and peaceful residential atmosphere — making Villa Veronique an ideal retreat for those seeking refined comfort in an enviable location.",
    highlights: [
      "Heated infinity pool overlooking Golf Valley",
      "Panoramic mountain & nature views",
      "Surrounded by world-class golf courses",
      "Fire pit and covered terrace for entertaining",
    ],
    distances: [
      { place: "Puerto Banús", time: "5 min drive" },
      { place: "Aloha Golf Club", time: "3 min drive" },
      { place: "Beach", time: "8 min drive" },
      { place: "Málaga Airport", time: "50 min drive" },
    ],
  },
  {
    slug: "villa-torremuelle",
    name: "Villa Torremuelle",
    location: "Benalmádena, Costa del Sol",
    image: villaTorremuelle,
    images: [villaTorremuelle, torremuelle2, torremuelle3, torremuelle4, torremuelle5, torremuelle6],
    bedrooms: "4",
    bathrooms: "4",
    guests: "Up to 8",
    pools: "1",
    features: [
      "Private pool with sea views",
      "Jacuzzi",
      "Fitness room",
      "Movie room",
      "Outdoor kitchen with BBQ",
      "Partial air conditioning",
      "Fireplace",
      "Smart TV throughout",
      "Laundry facilities",
      "Private balconies",
    ],
    pricing: {
      low: "€10.000",
      high: "€16.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Perched in the hills of Benalmádena, Villa Torremuelle invites you to unwind in a world where sky meets sea. With sweeping views stretching to Morocco on clear days, the villa offers a truly unique perspective on the Costa del Sol.\n\nThe four well-appointed bedrooms each feature en-suite bathrooms and private balconies with sea views. The living spaces include a movie room, fitness room, and an open-plan kitchen and dining area flowing onto a large terrace. Outside, a private pool with jacuzzi overlooks the Mediterranean, complemented by an outdoor kitchen with BBQ.\n\nBenalmádena offers a more relaxed pace along the Costa del Sol, with easy access to both Málaga and Marbella, making it an excellent base for exploring the region.",
    highlights: [
      "Sweeping sea views stretching to Morocco",
      "Private pool with jacuzzi",
      "Dedicated movie room & fitness room",
      "Outdoor kitchen for al fresco dining",
    ],
    distances: [
      { place: "Beach", time: "5 min drive" },
      { place: "Benalmádena Marina", time: "8 min drive" },
      { place: "Marbella", time: "30 min drive" },
      { place: "Málaga Airport", time: "20 min drive" },
    ],
  },
  {
    slug: "villa-magnifique",
    name: "Villa MAGNIFIQUE",
    location: "East Marbella, Costa del Sol",
    image: villaSuzanna,
    images: [villaSuzanna, suzanna2, suzanna3, suzanna4, suzanna5, suzanna6],
    bedrooms: "5",
    bathrooms: "6",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Heated chlorine pool",
      "Panoramic sea views",
      "SONOS sound system",
      "Wood fireplace",
      "Outdoor bar with sea view",
      "Game room",
      "Air conditioning throughout",
      "Mediterranean & tropical garden",
      "Fountain & water features",
      "BBQ area",
    ],
    pricing: {
      low: "€14.800",
      high: "€24.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Villa Suzanna is an idyllic, traditional Andalusian villa surrounded by Mediterranean gardens, complete with a cascading waterfall and breathtaking panoramic sea views. Located in East Marbella near a golf course, the villa offers a perfect blend of classic charm and modern comfort.\n\nThe villa features five luxurious bedrooms with six bathrooms, expansive living areas with SONOS sound system and wood fireplace, and a fully equipped kitchen. The outdoor bar with sea view provides the perfect spot for cocktails as the sun sets over the Mediterranean.\n\nThe lush tropical and Mediterranean gardens create a private oasis, while the heated pool and generous sun terraces invite long days of relaxation. A dedicated game room adds an element of fun for guests of all ages.",
    highlights: [
      "Traditional Andalusian architecture with sea views",
      "Outdoor bar with panoramic Mediterranean views",
      "Lush gardens with cascading waterfall",
      "Near golf course, close to Marbella centre",
    ],
    distances: [
      { place: "Marbella Old Town", time: "10 min drive" },
      { place: "Puerto Banús", time: "15 min drive" },
      { place: "Beach", time: "5 min drive" },
      { place: "Málaga Airport", time: "40 min drive" },
    ],
  },
];
